import Vue from 'vue'
import Router from 'vue-router'
import layout from '@/layout/index'
import bill from '@/views/bill'
import dict from '@/views/dict'
import statistics from '@/views/statistics'
import edition from '@/views/edition'
import login from '@/views/login/index'
import notice  from '@/views/notice'
import opinion  from '@/views/opinion'
import merchant  from '@/views/merchant'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/',
      component: layout,
      children: [
        {
          path: '/bill',
          name: 'bill',
          component: bill,
          meta: {
            title: '人员管理',
          }
        },{
          path: '/dict',
          name: 'dict',
          component: dict,
          meta: {
            title: '字典管理',
          }
        },{
          path: '/statistics',
          name: 'statistics',
          component: statistics,
          meta: {
            title: '综合统计',
          }
        },{
          path: '/edition',
          name: 'edition',
          component: edition,
          meta: {
            title: '版本管理',
          }
        },{
          path: '/notice',
          name: 'notice',
          component: notice,
          meta: {
            title: '公告管理',
          }
        },{
          path: '/opinion',
          name: 'opinion',
          component: opinion,
          meta: {
            title: '意见反馈',
          }
        },{
          path: '/merchant',
          name: 'merchant',
          component: merchant,
          meta: {
            title: '商户管理',
          }
        },
      ]}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js